import { mapGetters, mapActions } from 'vuex'

const mixin = {
  props: {
    componentIndex: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: () => ({
    hasBeenVisited: false
  }),
  watch: {
    isActiveSection(value) {
      if (value && !this.hasBeenVisited) {
        this.hasBeenVisited = true
        this.isOpen = true
      }
    }
  },
  computed: {
    ...mapGetters('checkout', ['checkoutState', 'activeSteps', 'isOrderRequestVisitorState']),
    isActiveSection() {
      return this.activeSteps.includes(this.componentIndex)
    }
  },
  methods: {
    ...mapActions('checkout', ['setCheckout', 'setActiveSteps', 'removeActiveSteps', 'setOrderRequestVisitor']),
    isStepActive(value) {
      return this.activeSteps.includes(value + 1)
    },
    saveActiveStep(value, reset = false) {
      var steps = this.activeSteps
      if (!reset && !steps.includes(value + 1)) {
        steps.push(value + 1)
        this.setActiveSteps(steps)
      }

      if (reset) {
        this.setActiveSteps(value)
      }
    },
    removeOnlyActiveSteps(steps) {
      this.removeActiveSteps(steps)
    },
    clearActiveSteps() {
      this.saveActiveStep([1], true)
      var current = this.checkoutState
      current.deliveryAddress = {}
      current.deliveryAddressId = null
      current.approveTerms = false
      current.idNumber = null
      current.pdfInvoiceEmail = null
      current.pdfReceiptEmail = null

      this.setOrderRequestVisitor(false)
      this.setCheckout(current)
    }
  },
  mounted() {
    if (this.componentIndex) {
      this.subscribe(`checkout-wizard-step-${this.componentIndex}`, (value) => {
        this.saveActiveStep(value)
      })
    }
  }
}

export default mixin
